import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { canAccessAction } from "./routePermissions";

interface ProtectedRouteProps {
  action?: string;
  children: ReactNode;
}

const ProtectedRoute = ({ action, children }: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading, permissions, roles } = useAuth();

  // Show skeleton loading state
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-slate-50">
        <div className="w-full max-w-sm space-y-3 p-8">
          <div className="cms-skeleton h-8 w-2/3 mx-auto" />
          <div className="cms-skeleton h-4 w-full" />
          <div className="cms-skeleton h-4 w-5/6" />
          <div className="cms-skeleton h-4 w-4/6" />
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!canAccessAction(action, permissions, roles)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
